import { Button, Checkbox, Divider, Menu, MenuItem, Typography } from "@mui/material";
import { ChangeEvent, Fragment, useState,useEffect } from "react";
import arrow from "../images/iconamoon_arrow-up-2-bold (1).svg"

interface Filter {
    Id: string;
    label: string;
    isVisible: boolean;
}
  
interface SelectedFilters {
    [key: string]: string[];
}

interface FilterListProps {
    filters: string[];
    filter: Filter;
    selectedFilters: SelectedFilters;
    updateSelectedFilters: (selectedFilters: SelectedFilters) => void;
    clearFilters: () => void;
    totalCounts: { [key: string]: number }; 
}

function FilterList({ filters, filter, selectedFilters, updateSelectedFilters, clearFilters,totalCounts }: FilterListProps) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const columnValues = filters&&filters.length > 0 ? filters : [];
    const [inputValue, setInputValue] = useState<string>('');
    const [showMessage, setShowMessage] = useState(false);
    const [filteredOptions, setFilteredOptions] = useState<string[]>(columnValues);
    const [checkedFilters, setCheckedFilters] = useState<string[]>([]);
    const [selectedFilterKey, setSelectedFilterKey] = useState<string>('');
    
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
        setInputValue('');
        setFilteredOptions(filters);
        setCheckedFilters(selectedFilters[filter.Id] || []);
        setSelectedFilterKey(filter.Id.toLowerCase());
    };

    const groups: string[][] = [];
    const columns = Math.ceil(filteredOptions.length / 9);
    for (let group = 0; group < filteredOptions.length; group += (columns > 4 ? 4 : columns)) {
        groups.push(filteredOptions.slice(group, group + (columns > 4 ? 4 : columns)));
    }
  
    const buttonStyles: React.CSSProperties = { marginLeft: '15px', textTransform: 'none', color: 'black', marginRight: '10px',marginTop:"7px",marginBottom:"7px", display: 'inline-block', textAlign: 'left', padding: 0, width: 'auto'};
    const searchStyles: React.CSSProperties = { border: '1px solid #959AC7', borderRadius: '8px', padding: '10px', fontSize: '15px', width: (columns === 2) ? '440px' : '385px', marginLeft: '5px', marginRight: '5px', marginBottom: '3px', outline:"none"};
    const menuItemStyles: React.CSSProperties = { paddingLeft: '8px', whiteSpace: 'normal', fontSize: '11pt' };

    const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        setCheckedFilters(selectedFilters[filter.Id]);
        const value = event.target.value.toLowerCase();
        setInputValue(event.target.value); 
    
        const extractedValues = columnValues.flatMap((item) => {
            if (typeof item === 'object' && item !== null) {
                return Object.values(item).filter((v): v is string => typeof v === 'string');
            }
            return [item];
        });
        const filtered = extractedValues.filter((columnValue) =>
            columnValue.toLowerCase().includes(value)
        );
        setFilteredOptions(filtered);
    };
  
    
    const handleFilterCheckboxChange = (value: string) => {
        if (value === "Select All") {
            if (showMessage && Array.isArray(columnValues)) {
                const allValues: string[] = Array.from(new Set(
                    columnValues.flatMap((item) => {
                        if (typeof item === 'object' && item !== null) {
                            return Object.values(item).filter((v): v is string => typeof v === 'string');
                        }
                        return [item];
                    })
                ));
               setCheckedFilters(checkedFilters.length < allValues.length ? allValues : []);
            } else {
                setCheckedFilters(checkedFilters.length < columnValues.length ? columnValues : []);
            }
            return;
        }
        const updatedFilters = checkedFilters.includes(value) ? checkedFilters.filter((filterValue) => { return filterValue !== value }) : [...checkedFilters, value];
        setCheckedFilters(updatedFilters);
    };


    const handleOkayButton = () => {    
        if (selectedFilters[filter.Id] === checkedFilters) {
            setAnchorEl(null);
            return;
        }
        const updatedFilters = { ...selectedFilters, [filter.Id]: [...checkedFilters] };
        if(!Object.values(updatedFilters).some((value) => value.length > 0)) {
            clearFilters();
        }
        updateSelectedFilters(updatedFilters);
        setAnchorEl(null);
        setCheckedFilters([]);
    }

let totalCount = 0;
let shouldShowMessage = false;
const groupedByLetter: { [key: string]: any[] } = {};
groups.forEach((group) => {
    group.forEach((item) => {
        if (typeof item === 'object' && item !== null) {
            const keys = Object.keys(item).filter(k => k !== 'Count');
            const value = keys.length > 0 ? String(item[keys[0]]) : '';

            if (keys.includes('Age')) {
                if (value.includes('weeks')) {
                    if (!groupedByLetter['Weeks']) {
                        groupedByLetter['Weeks'] = [];
                    }
                    groupedByLetter['Weeks'].push(item);
                } else if (value.includes('months')) {
                    if (!groupedByLetter['Months']) {
                        groupedByLetter['Months'] = [];
                    }
                    groupedByLetter['Months'].push(item);
                } else if (value.includes('years')) {
                    if (!groupedByLetter['Years']) {
                        groupedByLetter['Years'] = [];
                    }
                    groupedByLetter['Years'].push(item);
                }
            } else {
                const firstLetter = value.charAt(0).toUpperCase();
                if (!groupedByLetter[firstLetter]) {
                    groupedByLetter[firstLetter] = [];
                }
                groupedByLetter[firstLetter].push(item);
            }
        } 
        else {
            const value = String(item);
            let firstLetter = value.charAt(0).toUpperCase();
            if (value === 'Other') {
                    firstLetter='ZZ';
            }
                if (!groupedByLetter[firstLetter]) {
                    groupedByLetter[firstLetter] = [];
                }
                groupedByLetter[firstLetter].push(item);
            }
    });
});

const ageCategories = ['Weeks', 'Months', 'Years'];

const renderedItems = Object.keys(groupedByLetter)
    .sort((a, b) => {
        if (ageCategories.includes(a) && ageCategories.includes(b)) {
            return ageCategories.indexOf(a) - ageCategories.indexOf(b);
        }
        if (ageCategories.includes(a)) return -1;
        if (ageCategories.includes(b)) return 1;

        return a.localeCompare(b);
    })
    .map((letter, groupIndex) => {
        const group = groupedByLetter[letter];
        const isObjectArray = typeof group[0] === 'object' && group[0] !== null;
       
        const renderedValues = group.map((item, itemIndex) => {

            if (isObjectArray) {
                const keys = Object.keys(item).filter(k => k !== 'Count');
                if (keys.length === 1) {
                    const key = keys[0];
                    const value = String(item[key]);
                    totalCount = totalCounts[key] !== undefined ? totalCounts[key] : 0;
                    const count = item['Count'];
                    shouldShowMessage = true;

                    return (
                        <span key={`${key}-${itemIndex}`} style={{ display: 'flex' }}>
                            <Checkbox size="small" style={{ cursor: 'pointer', transform: 'scale(0.85)', padding: 0, color: checkedFilters.includes(value as string) ? "#364098" : "#959AC7", }} 
                                checked={checkedFilters.includes(value as string)} 
                                onChange={() => handleFilterCheckboxChange(value as string)} 
                            />
                            <MenuItem onClick={() => handleFilterCheckboxChange(value as string)} style={{ ...menuItemStyles, width: columns === 1 ? '385px' : '210px',padding:"10px" }}>
                                {`${value} ${count !== undefined ? `(${count})` : ''}`}
                            </MenuItem>
                        </span>
                    );
                }
            } else {
                const itemValue = item as string;
                return (
                    <span key={itemIndex} style={{ display: 'flex' }}>
                        <Checkbox size="small" style={{ cursor: 'pointer', transform: 'scale(0.85)', padding: 0, color: checkedFilters.includes(itemValue) ? "#364098" : "#959AC7"}} 
                            checked={checkedFilters.includes(itemValue)} 
                            onChange={() => handleFilterCheckboxChange(itemValue)} 
                        />
                        <Divider/>
                        <MenuItem onClick={() => handleFilterCheckboxChange(itemValue)} style={{ ...menuItemStyles, width: columns === 1 ? '385px' : '210px',padding:"10px" ,fontSize:"1rem",fontWeight:"400"}}>
                            {itemValue}
                        </MenuItem>
                       
                    </span>
                );
            }
            return null;
        });
    return (
        <div 
            key={groupIndex} 
            style={{ marginBottom: (filter.label === 'Contributor' || filter.label === 'Cell Type'|| filter.label === 'Tissue' || filter.label === 'Age') ? '20px' : '0'}}
        >
            {(
                filter.label === 'Contributor' ||
                filter.label === 'Cell Type'|| 
                filter.label === 'Tissue'||
                filter.label === 'Age'
            ) && letter && (
                <div style={{ fontWeight: '600', fontSize: '1.5rem', margin: '10px 0', marginLeft: '10px' }}>
                    {letter}
                </div>
            )}
    
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: '20px' }}>
                {renderedValues}
            </div>
        </div>
    );
});
const countRelevantFilters = ['Cell Type', 'Cell Line', 'Disease', 'Treatment','Treatment Response','Tissue','Organism'];
const originalTotalCount = countRelevantFilters.includes(filter.label) ? (totalCounts[filter.Id] || 0) : 0;
    useEffect(() => {
        setShowMessage(shouldShowMessage);
    }, [shouldShowMessage]);
    return (
        <Fragment>
            <div style={{backgroundColor:open?"#F5F5FF":"#FFFFFF",}}>
            <Button id="tablecolumn" aria-controls={open ? 'true' : undefined} aria-haspopup='true' aria-expanded={open ? 'true' : undefined} style={buttonStyles} onClick={handleClick}>
                {!open ? <Typography variant="h5" sx={{fontWeight:'500'}}>{filter.label}<img src={arrow} alt="down-arrow" style={{ margin: '9px'}} /></Typography>
                    : <span style={{ color: '#364098',backgroundColor: '#F5F5FF'}}>{filter.label}<img src={arrow} alt="down-arrow" style={{ margin: '9px'}} /></span>}
           
            </Button>
            <hr style={{width:"max(16vw,265px)",fontWeight:"10",border:"1px solid #CCCFEA"}}/>
            </div>
           
            <Menu id='menuId' aria-labelledby='tablecolumn' anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }} style={{minHeight:700}}>
         
            <div style={{ zIndex: 1, position: 'sticky', top: 0, display: 'flex', justifyContent: 'space-between', alignItems: 'center', overflowY: 'hidden', padding: '8px'}}>
                <Typography variant="h5" sx={{ fontWeight:'600',padding:"5px"}}>{filter.label}</Typography>
                {originalTotalCount> 0 &&  (
                <div style={{ fontWeight: '400',padding:"10px" }}>
                   <Typography variant="h6">Total number of {selectedFilterKey==='cellline'?'Cell Line':selectedFilterKey==='celltype'?'Cell Type':selectedFilterKey==='treatmentresponse'?'Treatment Responses':selectedFilterKey.charAt(0).toUpperCase() + selectedFilterKey.slice(1).toLowerCase()} :
                    <span style={{ fontWeight: 'bold' }}> {originalTotalCount}</span></Typography> 
                </div>

                )}
            </div>
            <div style={{ position:'relative',display: 'flex', padding:"1px 10px 10px 10px ", width: '100%',justifyContent:"centre"}}> 
                <input onFocus={(e) => e.stopPropagation()} 
  onKeyDown={(e) => e.stopPropagation()} className="focus-only" onChange={handleInputChange} type="text" placeholder="Search reference dataset" style={searchStyles} value={inputValue}/> 
            </div>
                <div style={{ height: '100%', overflowY: 'hidden' }}>
                    {renderedItems.length === 0 ? <MenuItem style={menuItemStyles}>No matches found</MenuItem> : 
                    <Fragment>
                       
                        <Divider/>
                    <div style={{ maxHeight: 300, overflow: 'auto' }}>
                    {inputValue !== 'filter.label' && <div style={{ display: 'flex', marginLeft: '20px'}}>
                            <Checkbox size="small" style={{ width:"15px",cursor: 'pointer', transform: "scale(0.85)", paddingLeft: "10px", color: checkedFilters.length === columnValues.length ? "#364098" : "#959AC7" }} checked={checkedFilters.length === columnValues.length} onChange={() => handleFilterCheckboxChange("Select All")}/>
                            <MenuItem onClick={() => handleFilterCheckboxChange("Select All")} style={{ paddingLeft: '10px', width: '85px', whiteSpace: 'normal', fontSize: '11pt' }}>Select All</MenuItem>
                        </div>}
                        {renderedItems}
                    </div>
                    <Divider/>
                    <div style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
              { showMessage &&(
        <div style={{ marginRight: '7px',marginLeft:"7px", display: 'flex', alignItems: 'center' }}>
            <Typography variant="h6" style={{ whiteSpace: "pre-line" }}>
                ** The number inside the brackets specifies {"\n"} the sample count
            </Typography>   
        </div>
    )}
    <Button onClick={handleOkayButton} size="small" variant="contained" style={{ backgroundColor: '#364098', color: 'white', textTransform: 'none', height: '40px', width:"80px",marginLeft: 'auto', marginRight: '5px', marginTop: '8px',borderRadius:"10px" }}>
        OK
    </Button>
             </div>
         </Fragment>}
         </div>

        
            </Menu>
          
        </Fragment>
    );
  }

  export default FilterList;